<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="MESNAZAJEDNICA.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                #focusElement                
                [MaxLength]="50"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'MESNAZAJEDNICA.NAZIV.SINGULAR'"
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                    <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
                </div>
            </div>
          </div>
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="MESNAZAJEDNICA.MESTOID.SINGULAR"></span></label> -->
              <div class="col-md-12">
                  <!-- <yt-fw-dropdown
                  [ModelName]="'mesto'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]='true'                                
                  name="cmbMesto"
                  formControlName="MestoID"
                  [Type]="ID"
                  [ngClass]="{'is-invalid': submitted && fc.MestoID.invalid}"
                  [Label]="'MESNAZAJEDNICA.MESTOID.SINGULAR'"
                  >
                </yt-fw-dropdown> -->

                <!-- <yt-dropdown-picklist
                    [ModelName]="'mesto'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="true"
                    formControlName="MestoID"
                    [Label]="'BANKA.MESTO.SINGULAR'"
                    > 
              </yt-dropdown-picklist> -->

              <yt-autocomplete
              [ModelName]="'mesto'"
              [GetName]="'getByNaziv'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [Label]="'MESNAZAJEDNICA.MESTO.SINGULAR'"
              formControlName="MestoID">
            </yt-autocomplete>
          <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
                    <span *ngFor="let validation of errorMessages.MestoID">
                      <span class="error-message" *ngIf="fc.MestoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                      <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</form>